module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "Configure Two Factor Authentication",
      "size": "md",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [(_vm.is_loading === false) ? _c('div', {
    staticClass: "h-full relative"
  }, [(_vm.is_enable === false) ? _c('div', {
    staticClass: "h-full"
  }, [_c('div', {
    staticClass: "h-full flex flex-col"
  }, [_c('div', {
    staticClass: "flex-grow h-full px-8 py-5"
  }, [_c('ul', {
    staticClass: "flex flex-col space-y-4 flex-grow h-full"
  }, [_c('li', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('div', {
    staticClass: "flex items-start justify-between"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_vm._v("\n                    1. You will need an authenticator mobile app to complete\n                    this process:\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-5 flex flex-col space-y-2"
  }, [_c('span', {
    staticClass: "underline text-blue-500 cursor-default"
  }, [_vm._v("Google Authenticator")]), _vm._v(" "), _c('span', {
    staticClass: "underline text-blue-500 cursor-default"
  }, [_vm._v("Microsoft Authenticator")]), _vm._v(" "), _c('span', {
    staticClass: "underline text-blue-500 cursor-default"
  }, [_vm._v("Duo Mobile")])])]), _vm._v(" "), (_vm.qrcode) ? _c('div', {
    staticClass: "w-44 h-44"
  }, [_c('img', {
    attrs: {
      "src": _vm.qrcode
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "flex flex-col space-y-2 mb-6"
  }, [_c('div', [_vm._v("2. Scan the QRCode with your authenticator")]), _vm._v(" "), _c('div', {
    staticClass: "ml-5 flex flex-col space-y-2"
  }, [_c('span', {
    staticClass: "text-blueGray-600 font-light"
  }, [_vm._v("If you can't scan the QRCode use this code:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secret),
      expression: "secret"
    }],
    staticClass: "px-3 py-2 rounded border border-solid border-gray-200",
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": (_vm.secret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secret = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "flex flex-col space-y-2 mt-10"
  }, [_c('div', [_vm._v("\n                3. After scanning the QRCode, enter the code\n                generated by authenticator mobile app\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-5 flex flex-col space-y-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    staticClass: "px-3 py-2 rounded border border-solid border-gray-200",
    attrs: {
      "placeholder": "Enter six code generated..."
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-8 py-5"
  }, [_c('div', {
    staticClass: "flex items-center justify-end space-x-3"
  }, [_c('button', {
    staticClass: "bg-gray-50 hover:bg-gray-100 border text-blueGray-800 border-solid border-gray-200 px-3 py-2 rounded",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-primary flex items-center space-x-2 px-3 py-2 border border-solid border-primary rounded text-white",
    on: {
      "click": function($event) {
        return _vm.handleVerify2FA()
      }
    }
  }, [_c('span', [_vm._v("Verify Now")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_verify),
      expression: "is_verify"
    }],
    staticClass: "loader"
  })])])])])]) : _c('div', {
    staticClass: "h-full"
  }, [_c('div', {
    staticClass: "flex flex-col h-full"
  }, [_c('div', {
    staticClass: "flex-grow h-full px-8 py-6"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-3"
  }, [_c('div', {
    staticClass: "w-8/12 text-gray-800"
  }, [_vm._v("\n              To remove\n              "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Two Factor Authentication (2FA)")]), _vm._v(", enter the six digit code, generated by authenticator mobile\n              app\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formattedInput),
      expression: "formattedInput"
    }],
    staticClass: "px-3 py-2 focus:border-red-500 rounded border border-solid border-gray-200",
    attrs: {
      "maxlength": "7",
      "placeholder": "Enter six code generated..."
    },
    domProps: {
      "value": (_vm.formattedInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formattedInput = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "py-5 px-8"
  }, [_c('div', {
    staticClass: "flex justify-end items-end"
  }, [_c('button', {
    staticClass: "bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded",
    on: {
      "click": function($event) {
        return _vm.handleRemove()
      }
    }
  }, [_vm._v("\n              Remove Two Factor Authentication\n            ")])])])])])]) : _c('div', {
    staticClass: "h-full flex justify-center items-center"
  }, [_c('pl-spinner', {
    staticStyle: {
      "width": "40px",
      "height": "40px"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-045e95cf!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/Enable2FAModal.vue
// module id = 1636
// module chunks = 61